module.exports = __webpack_public_path__ + "assets/img/section-1-landing-page-pj-full.6182deef.png";